module.exports = __webpack_public_path__ + "static/img/card_2_1.16e71ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_2_1.png
// module id = llV0
// module chunks = 0